import { render, staticRenderFns } from "./ReportSendSettingsForm.vue?vue&type=template&id=6ed4e64c&scoped=true"
import script from "./ReportSendSettingsForm.vue?vue&type=script&lang=js"
export * from "./ReportSendSettingsForm.vue?vue&type=script&lang=js"
import style0 from "./ReportSendSettingsForm.vue?vue&type=style&index=0&id=6ed4e64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed4e64c",
  null
  
)

export default component.exports